import DealRoomFieldRequiredVisibleInfo from './DealRoomFieldRequiredVisibleInfo.component';

export default DealRoomFieldRequiredVisibleInfo;
